import { ComponentElem } from "@components/interfaces";
import isEqual from "lodash.isequal";
import PopupBase from "./PopupBase";
import Popups from "./Popups";
import {gsap} from "gsap";

export type PickDateRangeResult = {
  start?: moment.Moment
  end?: moment.Moment
  isReset?: boolean
}


const MY_DATE_FORMAT = "MM/DD/YYYY";

///@ts-ignore
// console.log(moment.locale("zh-tw"));

const DEFAULT_OPTIONS = {

  linkedCalendars: false,

  autoUpdateInput: false,
  locale: {
    // format: GS.DATE_FORMAT,
    cancelLabel: '取消', 
    applyLabel: "OK",
    daysOfWeek: ["日", "一", "二", "三", "四", "五", "六"],
    monthNames: ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']
  },
  isCustomDate: function (obj: any)
  {
    // console.log(obj);
    return "custom-date-cell";
  }
};

///@ts-ignore
// moment.updateLocale("de", {
//   // months : ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月'],
//   monthsShort  : ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']
// });

export default class PickDateRange extends PopupBase
{
  static instance: PickDateRange;

  $input: JQuery;
  $cover: JQuery;

  picker: daterangepicker;

  private _cbOnInput: Function;

  private _isPending: boolean = false;

  currentOptions: any = {
  };

  constructor(elem: ComponentElem)
  {

    super(elem);

    this.$cover = $(`<div class="pending-cover"></div>`);

    let dateInput = this.$root.find(".my-input")[0] as HTMLInputElement;
    this.$input = $(dateInput);

    dateInput.value = "";

    this._applyOptions({ singleDatePicker: false });

    PickDateRange.instance = this;    

    this.$root.append(this.$cover);
    this.togglePending(false);
    
  }

  requestSingle(targetElem?: HTMLElement, start?: moment.Moment, setBackPopup?: string, extraOptions?: any)
  {
    let startDate: string;

    if (start) {
      startDate = start.format(MY_DATE_FORMAT);
    }
    else {
      ///@ts-ignore
      let today = moment();
      startDate = today.format(MY_DATE_FORMAT);
    }

    // console.log(startDate);
    

    let options = {
      singleDatePicker: true,
      // isInvalidDate: isInvalidDate,
      startDate: startDate
    };

    if (extraOptions) {
      options = Object.assign({}, options, extraOptions);
    }

    this._applyOptions(options);

    this._tryOpen(targetElem, setBackPopup);
    

    

    return new Promise((resolve) =>
    {
      this._cbOnInput = (result: PickDateRangeResult)=>
      {
        targetElem ? Popups.closeMenu() : Popups.close();
        resolve(result);
      }
    });
  }

  request(targetElem?: HTMLElement, start?: moment.Moment, end?: moment.Moment, setBackPopup?: string)
  {
    this._applyOptions({ singleDatePicker: false });

    if (start && end) {
      this.picker.setStartDate(start);
      this.picker.setEndDate(end);
    }
    else {
      ///@ts-ignore
      let today = moment();
      // console.log(today.format(`MM/DD/YYYY`));
      this.picker.setStartDate(today);
      this.picker.setEndDate(today);
    }

    // this._cbOnInput = cb;

    this._tryOpen(targetElem, setBackPopup);

    return new Promise((resolve) =>
    {
      this._cbOnInput = (result: PickDateRangeResult)=>
      {
        targetElem ? Popups.closeMenu() : Popups.close();
        resolve(result);
      }
    });
  }

  _tryOpen(targetElem?: HTMLElement, setBackPopup?: string)
  {
    if (targetElem) {

      $("#dropdown-menus").append(this.$root);
      this.$input.click();
      this.$root.detach();

      Popups.openMenu("pick-date-range", targetElem);
    }
    else {
      // Popups.openMenuAsPopup("pick-date-range");

      this.$root.css("opacity", 0);

      $("#popups").append(this.$root);
      this.$input.click();
      this.$root.detach();

      Popups.to("pick-date-range", setBackPopup);
    }
  }

  _applyOptions(options: any)
  {
    let self = this;

    return new Promise((resolve) =>
    {
      options = Object.assign({}, DEFAULT_OPTIONS, options);
      options.parentEl = this.$root[0];

      // console.log(options);

      if (!isEqual(this.currentOptions, options)) {

        if (this.picker) this.picker.remove();
        this.currentOptions = options;
        this.$input.daterangepicker(options);
        this.picker = this.$input.data('daterangepicker');

        this.$input.on('apply.daterangepicker', function (ev: any, picker: any)
        {
          // console.log("pick");       

          Popups.closeMenu();

          if (self._cbOnInput) self._cbOnInput.call(null, { start: picker.startDate, end: picker.endDate });
          self._cbOnInput = undefined;
        });

        

        this.$input.on("showCalendar.daterangepicker", (ev: any, picker: any)=>
        {
          // console.log("showCalendar.daterangepicker");

          if(this.currentOptions.onMonthChange)
          {
            ///@ts-ignore
            let date = moment(picker.leftCalendar.month._d),
            year = date.year(),
            month = date.month() + 1;

            this.currentOptions.onMonthChange.call(null, year, month);
          }

        });

        // this.$input.on("hide.daterangepicker", (ev: any, picker: any)=>
        // {
        //   console.log("hideCalendar.daterangepicker");
        // });
        

        // this.$input.on("show.daterangepicke", function (ev: any, picker: any)
        // {
        //   console.log("show.daterangepicke");
        // });

        this.$input.on('cancel.daterangepicker', function (ev: any, picker: any)
        {
          $(this).val('');

          if (self._cbOnInput) self._cbOnInput.call(null, {isReset: true});
          self._cbOnInput = undefined;
        });
      }

    });
  }

  togglePending(b: boolean)
  {
    let oldValue = this._isPending;
    this._isPending = b;

    gsap.killTweensOf(this.$cover[0]);

    if(this._isPending)
    {
      gsap.set(this.$cover[0], {opacity: 0, display: "block"});
      gsap.to(this.$cover[0], {duration: .01, opacity: 1});
    }
    else
    {
      gsap.to(this.$cover[0], {duration: .15, opacity: 0, clearProps: "display"});
    }
  }

  update()
  {
    ///@ts-ignore
    this.picker.updateCalendars();
  }

  cancel()
  {
    Popups.closeMenu();
  }


}